import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useSpring, animated } from 'react-spring';
import '../styles.css';
import HumanIcon from '../COMPONENTS/HumanIcon';
import RobotIcon from '../COMPONENTS/RobotIcon';
import { PN_BLUE, PN_RED, PN_PURPLE, PN_YELLOW, PN_GREEN } from '../const';
import { SET_TURN, UNSELECT_TILE } from '../REDUX/actions';

const Player = ({ ai, style, one }) => {
  const dispatch = useDispatch();
  const { skill, turn, started } = useSelector(state => state.pn);
  const color = ai ? (skill === 1 ? PN_GREEN : skill === 2 ? PN_YELLOW : PN_RED) : one ? PN_BLUE : PN_PURPLE;
  const rotate = turn && one ? turn === 1 : turn === 2;
  const [degree, setDegree] = useState(0);

  const handleClick = () => {
    if (started) {
      return;
    }

    dispatch(UNSELECT_TILE);
    dispatch({ type: SET_TURN, turn: one ? 1 : 2 });
  };

  const { transform } = useSpring({
    transform: `rotateY(${rotate ? degree : 0}deg)`,
    config: { duration: 400 },
    onRest: () => {
      if (rotate) {
        setDegree(90 - degree);
      }
    },
  });

  return (
    <animated.div style={{ ...style, transform }} onClick={handleClick}>
      {ai ? <RobotIcon width="50px" color={color} /> : <HumanIcon width="50px" color={color} />}
    </animated.div>
  );
};

export default Player;
